import {
  Icon,
  IconAirfare,
  IconBills,
  IconFunds,
  IconOrder,
  IconRequest,
  IconVendor,
} from '@procurify/ui'

import { GlobalSearchListItemIconStyled } from './styles/GlobalSearchListItemIconStyled'
import {
  type GlobalSearchResultTypeEnum,
  GlobalSearchResultTypes,
} from '../../../../../../value-objects/enums'

interface IGlobalSearchListItemIconProps {
  type: GlobalSearchResultTypeEnum
}

export const GlobalSearchListItemIcon = ({
  type,
}: IGlobalSearchListItemIconProps) => {
  const icon = (() => {
    switch (type) {
      case GlobalSearchResultTypes.ORDER_REQUEST:
        return <IconRequest size={22} color='darkGrey' />
      case GlobalSearchResultTypes.EXPENSE_REQUEST:
        return <Icon icon='other' size={22} color='darkGrey' />
      case GlobalSearchResultTypes.TRAVEL_REQUEST:
        return <IconAirfare size={22} color='darkGrey' />
      case GlobalSearchResultTypes.PURCHASE_ORDER:
        return <IconOrder size={22} color='darkGrey' />
      case GlobalSearchResultTypes.BILL:
        return <IconBills size={22} color='darkGrey' />
      case GlobalSearchResultTypes.PAYMENT:
        return <IconFunds size={22} color='darkGrey' />
      case GlobalSearchResultTypes.VENDOR:
        return <IconVendor size={22} color='darkGrey' />
      case GlobalSearchResultTypes.CATALOG_ITEM:
        return <Icon icon='catalog' size={22} color='darkGrey' />
      case GlobalSearchResultTypes.CONTRACT:
        return <Icon icon='edit-log' size={22} color='darkGrey' />
      default:
        return null
    }
  })()

  if (!icon) {
    return null
  }

  return (
    <GlobalSearchListItemIconStyled aria-hidden='true'>
      {icon}
    </GlobalSearchListItemIconStyled>
  )
}
